import { CreateCatEventPayloadDto } from 'libs/pinnacle-sdk';
import * as yup from 'yup';

export const getValidationSchema = (t: any) =>
  yup.object().shape({
    eventName: yup
      .string()
      .trim()
      .required(t('validation.required', { field: t('catEvent.eventName') })),
    fromDate: yup
      .date()
      .required(t('validation.required', { field: t('catEvent.fromDate') })),
    toDate: yup
      .date()
      .required(t('validation.required', { field: t('catEvent.toDate') }))
      .min(
        yup.ref('fromDate'),
        t('validation.dateAfterInception', {
          field: t('catEvent.toDate'),
          date: t('catEvent.fromDate'),
        })
      ),
    country: yup
      .string()
      .required(t('validation.required', { field: t('general.country') })),
    description: yup.string().optional(),
  });

export const initialValues = {
  eventName: undefined,
  fromDate: null,
  toDate: null,
  country: undefined,
};

export const fields = Object.keys(
  initialValues
) as (keyof CreateCatEventPayloadDto)[];
